import React, { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { DATASET, globalSetDataset, modeExecution , SITE_WEB } from './Global.js';






const ResultList = () => {

    const location = useLocation();
    const navigate = useNavigate();

    const { csvData } = location.state || { csvData: [] };
    const [searchTerm1, setSearchTerm1] = useState('');
    const [searchTerm2, setSearchTerm2] = useState('');



    if (csvData.length === 0) {
        return <div>Aucun résultat à afficher. Veuillez uploader un fichier CSV.</div>;
    }

    //----------------------------------------------------------------
    const handleItemClick = (originalIndex) => {
        const result = csvData[originalIndex];
        navigate('/compare', { state: { result, index: originalIndex, csvData } });
    };

    //----------------------------------------------------------------
    const filteredResults = csvData.filter((result) => {

        const name1 = result.name1 ? result.name1.toLowerCase() : '';
        const name2 = result.name2 ? result.name2.toLowerCase() : '';
    
        const term1 = searchTerm1.toLowerCase();
        const term2 = searchTerm2.toLowerCase();
    
        return (name1.includes(term1) || name2.includes(term1)) &&
               (name1.includes(term2) || name2.includes(term2));
    }); // FIN  csvData.filter








    return(
        <div className="container">
            <h1>Liste des Résultats</h1>
            <div>
                <input
                    type="text"
                    placeholder="Rechercher des liaisons..."
                    className="form-control mb-3"
                    value={searchTerm1}
                    onChange={(e) => setSearchTerm1(e.target.value)}
                />
                <input
                    type="text"
                    placeholder="Rechercher des liaisons..."
                    className="form-control mb-3"
                    value={searchTerm2}
                    onChange={(e) => setSearchTerm2(e.target.value)}
                />
            </div>

            <div className="row">
                {filteredResults.length > 0 ? (
                    filteredResults.map((result, index) => {
                        // On trouve l'index original de l'élément dans la liste csvData
                        const originalIndex = csvData.indexOf(result);
     
                        let transformedPath1 = ''
                        let transformedPath2 = ''       

                        console.log("RESULT LIST!!!")

                        //----------------------------------------------------------------
                        const token = sessionStorage.getItem('token');
                        if (token) {
                            axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
                        }
                        // console.log("token : " , token)
                            

                        //---------------------------------------------------------------- transformPathSimple
                        const transformPathSimple = (imageSrc, callback) => {
                            const img = new Image();
                            // img.crossOrigin = 'Anonymous';
                            img.src = imageSrc;
                        
                            img.onload = () => {
                            const canvas = document.createElement('canvas');
                            const ctx = canvas.getContext('2d');
                            canvas.width = img.width;
                            canvas.height = img.height;
                            ctx.fillStyle = 'white';
                            ctx.fillRect(0, 0, canvas.width, canvas.height);
                        
                            const src = window.cv.imread(img);
                        
                            const resultCanvas = document.createElement('canvas');
                            window.cv.imshow(resultCanvas, src);
                            const transformedSrc = resultCanvas.toDataURL();
                            src.delete();
                        
                            callback(transformedSrc);
                            };
                        
                            img.onerror = (err) => {
                            console.error("[transformPathSimple] Erreur lors du chargement de l'image :", err);
                            };
                        }; // FIN transformPathSimple

                        //---------------------------------------------------------------- path1
                        let path1;
                        path1 = SITE_WEB + '/images/' + result.name1
                        // console.log("path1 : " , path1)

                        let path1_imageURL = ''
                            
                        axios.get(path1, {
                                params:{dataset:DATASET},
                                headers: { 'Authorization': `Bearer ${token}`}, // PAT
                                responseType: 'blob', // Nécessaire si on veut travailler avec des blobs d'image
                                withCredentials: true
                        })
                        .then(response => {
                            // console.log("response.data : " , response.data)
                            path1_imageURL = URL.createObjectURL(response.data);    
                            transformPathSimple(path1_imageURL, (transformedSrc1) => {
                            // setTransformedPath1(transformedSrc1);
                            transformedPath1 = transformedSrc1;
                            });
                        })
                        .catch(error => {
                            console.error("[path1_imageURL] Erreur lors du chargement de l'image :", error);
                        });
                        
                        //---------------------------------------------------------------- path2
                        //const path2 = `http://localhost:3001/images/${result.name2}`;
                        const path2 = `${process.env.REACT_APP_API_URL}/images/${result.name2}`;
                        let path2_imageURL = ''
                            
                        axios.get(path2, {
                                params:{dataset:DATASET},
                                headers: {'Authorization': `Bearer ${token}`}, // PAT
                                responseType: 'blob', // Nécessaire si on veut travailler avec des blobs d'image
                                withCredentials: true
                        })
                        .then(response => {
                            // console.log("response.data : " , response.data)
                            path2_imageURL = URL.createObjectURL(response.data);    
                            transformPathSimple(path2_imageURL, (transformedSrc2) => {
                                // setTransformedPath2(transformedSrc2);
                                transformedPath2 = transformedSrc2;
                            });
                        })
                        .catch(error => {
                            console.error("[path2_imageURL] Erreur lors du chargement de l'image :", error);
                        });

                        console.log("transformedPath1 : ", transformedPath1)
                        console.log("transformedPath2 : ", transformedPath2)
                        

                        return (
                            <div
                                key={originalIndex} // On utilise l'indice original comme clé
                                className="col-md-6"
                                onClick={() => handleItemClick(originalIndex)}
                                style={{ cursor: 'pointer' }}
                            >
                                <li className="list-group-item">
                                    <div className="row">
                                        <div className="col">
                                            <p>{originalIndex + 1}</p> {/* Utilisation de l'indice original */}
                                        </div>
                                        <div className="col">
                                            {/* <img src={`${process.env.REACT_APP_API_URL}/images/${result.name1}`} alt={result.name1} width="100" /> */}
                                            <img 
                                                src={transformedPath1}
                                                alt={result.name1}
                                                width="100"
                                                crossOrigin="use-credentials"
                                            />                                        
                                        </div>
                                        <div className="col">
                                            {/* <img src={`${process.env.REACT_APP_API_URL}/images/${result.name2}`} alt={result.name2} width="100" /> */}
                                            <img 
                                                src={transformedPath2} 
                                                alt={result.name2} 
                                                width="100" 
                                                crossOrigin="use-credentials"
                                            />
                                        </div>
                                        <div className="col">
                                            <p>{result.name1}    -    {result.name2}</p>
                                        </div>
                                    </div>
                                </li>
                            </div>
                        );
                    })
                ) : (
                    <p>Aucun résultat trouvé.</p>
                )}
            </div>
        </div>
    );
};


// <img
// // src={`${process.env.REACT_APP_API_URL}/images/${name1}?token=${token}&dataset=${DATASET}`}
// src={transformedPath1}
// alt={name1}
// className="miniature-img me-2"
// crossOrigin="use-credentials"
// />


export default ResultList;
